// extracted by mini-css-extract-plugin
export default {"container":"MenuSubitem_container__ZpEKX","icon":"MenuSubitem_icon__1qxqQ","title":"MenuSubitem_title__yP5+F","selected":"MenuSubitem_selected__Z1ijG"};